module.exports = __webpack_public_path__ + "img/category_3.2f8b7036.svg";